module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-menu mt-2 ml-3"
  }, _vm._l((_vm.root.elements), function(element) {
    return _c('div', {
      key: element.title
    }, [_c('div', {
      staticClass: "menu-item page hoverable clickable",
      class: {
        'active': _vm.isActive(element), 'complete': element.percent > 54
      },
      on: {
        "click": function($event) {
          return _vm.nodeClicked(element, null)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('div', {
      staticClass: "behind-circular"
    }, [_c('v-progress-circular', {
      staticClass: "solid",
      staticStyle: {
        "border-radius": "4px",
        "margin": "-1px"
      },
      attrs: {
        "background-color": "grey lighten-2",
        "color": "blue lighten-1",
        "width": 5,
        "size": 35,
        "rotate": 265,
        "value": element.percent
      }
    }, [(element.percent > 0) ? _c('v-icon', {
      staticClass: "check-icon",
      attrs: {
        "color": "blue darken-1"
      }
    }, [_vm._v(_vm._s((element.percent == 100 ? 'check' : 'more_horiz')))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
      staticClass: "arrow-icon",
      attrs: {
        "color": "blue darken-1"
      }
    }, [_vm._v(_vm._s(element.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding": "5px",
        "border-radius": "0 18px 18px 0"
      }
    }, [_vm._v(_vm._s(element.title))]), _vm._v(" "), _c('div', {
      staticClass: "callout"
    })]), _vm._v(" "), _c('v-expand-transition', [(element.expanded) ? _c('div', {
      staticClass: "sections"
    }, _vm._l((element.elements), function(subElement) {
      return _c('div', {
        key: subElement.title,
        staticClass: "menu-item section hoverable clickable",
        class: {
          'active': _vm.isActive(subElement), 'complete': subElement.complete
        },
        on: {
          "click": function($event) {
            return _vm.nodeClicked(element, subElement)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex-basis": "40px"
        }
      }, [_c('div', {
        staticClass: "horizontal-branch"
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding": "10px 5px",
          "flex-grow": "1"
        }
      }, [_vm._v("\n                    " + _vm._s(subElement.title) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "callout"
      })])
    }), 0) : _vm._e()])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c23c0fba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ElementMenu.vue
// module id = 2653
// module chunks = 1